import { IThemeModel } from "../models/IThemeModel";

export const ilionxTheme: IThemeModel = {
    primaryColor: "#E41D29",
    secondaryColor: "green",

    // borders
    borderNeutral: "#ccc",
    borderContentSeperator: "#ddd",

    // text colors
    primaryTextColor: "#616161",
    primaryNavigationTextColor: "#737373",

    // header
    headerBackgroundColor: "#fff",
};
